import socketIOClient from "socket.io-client";
var Raxios = require('axios');
// import { SITE_URL } from "@env"

// const SITE_URL = 'http://api.cryptinix.com/api';
// const SOCKET_URL = 'http://api.cryptinix.com:8082';


const SITE = "https://api.cryptinix.com";
const SITE_URL = "https://api.cryptinix.com/api";
const SOCKET_URL = "https://api.cryptinix.com";

// kooliyadan - wifi
// const SITE = 'https://localhost:8080';
// const SITE_URL = 'https://localhost:8080/api';
// const SOCKET_URL = 'http://localhost:8083';
// haris - wifi
// const SITE_URL = 'http://172.20.10.4/api';
// const SOCKET_URL = 'http://172.20.10.4:8082'; 


// // // oneplus8tip
// const SITE = 'http://192.168.143.234/';
// const SITE_URL = 'http://192.168.143.234/api';
// const SOCKET_URL = 'http://192.168.143.234:8083'
// // // // // // testServer
// const SITE = 'http://15.185.110.185';
// const SITE_URL = 'http://15.185.110.185/api';
// const SOCKET_URL = 'http://15.185.110.185:8083';

let axios = new Raxios.create({
  baseURL: SITE_URL,
  header: {
    'Content-type': 'application/json'
  }
})
axios.interceptors.response.use(res => {
  return Promise.resolve(res.data);
}, error => {
  let err = {
    ...error.response.data,
    resposnseCode: error.response.status
  }
  return Promise.reject(err);
});


axios.interceptors.request.use(req => {
  // console.log(req);
  return Promise.resolve(req);

});


const getHeader = (auth) => {
  return {
    headers: {
      'Authorization': 'Bearer ' + (auth.isAuthenticated ? auth.token : ''),
      'Content-Type': "application/json;charset=utf-8",
    }
  }
}

const socket = socketIOClient(SOCKET_URL, { transports: ['websocket', 'polling', 'flashsocket'] });

export { axios, getHeader, SOCKET_URL, socket, SITE }


